import { render, staticRenderFns } from "./home-box8.vue?vue&type=template&id=e8acc454&scoped=true&"
import script from "./home-box8.vue?vue&type=script&lang=js&"
export * from "./home-box8.vue?vue&type=script&lang=js&"
import style0 from "./home-box8.vue?vue&type=style&index=0&id=e8acc454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8acc454",
  null
  
)

export default component.exports